import React, { useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { useNavigate } from "react-router-dom";

const input = { width:"100%", padding:12, borderRadius:12, border:"1px solid rgba(255,209,59,.3)", background:"rgba(0,0,0,.35)", color:"#e9eef5", margin:"8px 0" };
const btn   = { background:"#ffd13b", color:"#0b0f14", padding:"10px 16px", borderRadius:999, border:"none", fontWeight:800, cursor:"pointer" };

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try { await login(email, pass); nav("/admin"); }
    catch { setErr("Invalid login"); }
  };

  return (
    <div style={{ maxWidth: 420, margin: "90px auto", padding: 20, color:"#e9eef5" }}>
      <h1 style={{ color:"#ffd13b" }}>Admin Login</h1>
      <form onSubmit={submit}>
        <input style={input} placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} />
        <input style={input} placeholder="Password" type="password" value={pass} onChange={e=>setPass(e.target.value)} />
        {err && <p style={{ color: "salmon" }}>{err}</p>}
        <button style={btn}>Login</button>
      </form>
    </div>
  );
}
